import { render, staticRenderFns } from "./product-type-add.vue?vue&type=template&id=34a124f2&scoped=true&"
import script from "./product-type-add.vue?vue&type=script&lang=js&"
export * from "./product-type-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a124f2",
  null
  
)

export default component.exports